let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kmPVt")).then(() => parcelRequire('aUnGu'));